/* eslint-disable camelcase */
const AgilityMobile = ({ databoxes: { percent_mobile } }) =>
  `${percent_mobile}% of users were in occupation between 20 and 50%
   of the time and are likely to be more mobile than their fixed and
   flexible colleagues, often being out of the building.`;

export default AgilityMobile;
